/** Historia clínica adulto — schema_version 2 (NOM-004 / podología) */

export const INTAKE_SCHEMA_VERSION = 2;

export const MARITAL_STATUS_OPTIONS = [
  { value: 'soltero', label: 'Soltero(a)' },
  { value: 'casado', label: 'Casado(a)' },
  { value: 'union_libre', label: 'Unión libre' },
  { value: 'viudo', label: 'Viudo(a)' },
  { value: 'divorciado', label: 'Divorciado(a)' },
];

export const EDUCATION_OPTIONS = [
  { value: 'sin_escolaridad', label: 'Sin escolaridad' },
  { value: 'primaria', label: 'Primaria' },
  { value: 'secundaria', label: 'Secundaria' },
  { value: 'preparatoria', label: 'Preparatoria' },
  { value: 'licenciatura', label: 'Licenciatura' },
  { value: 'posgrado', label: 'Posgrado' },
];

export const BLOOD_TYPE_OPTIONS = [
  'A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-',
];

export const EVOLUTION_UNITS = [
  { value: 'dias', label: 'Días' },
  { value: 'semanas', label: 'Semanas' },
  { value: 'meses', label: 'Meses' },
  { value: 'anos', label: 'Años' },
];

export const PROGNOSIS_OPTIONS = [
  { value: 'bueno', label: 'Bueno' },
  { value: 'reservado', label: 'Reservado' },
  { value: 'malo', label: 'Malo' },
];

export const FOOTWEAR_HABIT_OPTIONS = [
  { id: 'seguridad', label: 'Seguridad' },
  { id: 'tacon', label: 'Tacón' },
  { id: 'deportivo', label: 'Deportivo' },
  { id: 'cerrado', label: 'Cerrado' },
  { id: 'sandalia', label: 'Sandalia' },
  { id: 'ortopedico', label: 'Ortopédico' },
];

export const FOOT_HYGIENE_OPTIONS = [
  { value: 'adecuada', label: 'Adecuada' },
  { value: 'regular', label: 'Regular' },
  { value: 'deficiente', label: 'Deficiente' },
];

export const CARDIOVASCULAR_CONDITIONS = [
  { id: 'hipertension', label: 'Hipertensión' },
  { id: 'arritmias', label: 'Arritmias' },
  { id: 'insuficiencia_venosa', label: 'Insuficiencia venosa' },
  { id: 'cardiopatias', label: 'Cardiopatías' },
  { id: 'marcapasos', label: 'Marcapasos' },
  { id: 'anticoagulante', label: 'Anticoagulante' },
];

export const ENDOCRINE_CONDITIONS = [
  { id: 'dm1', label: 'DM tipo 1' },
  { id: 'dm2', label: 'DM tipo 2' },
  { id: 'hipotiroidismo', label: 'Hipotiroidismo' },
  { id: 'hipertiroidismo', label: 'Hipertiroidismo' },
];

export const DERMATOLOGICAL_CONDITIONS = [
  { id: 'psoriasis', label: 'Psoriasis' },
  { id: 'dermatitis', label: 'Dermatitis' },
  { id: 'micosis', label: 'Micosis' },
  { id: 'celulitis', label: 'Celulitis' },
  { id: 'ulceraciones', label: 'Ulceraciones previas' },
];

export const NEUROLOGICAL_CONDITIONS = [
  { id: 'neuropatia_diabetica', label: 'Neuropatía diabética' },
  { id: 'parkinson', label: 'Parkinson' },
  { id: 'epilepsia', label: 'Epilepsia' },
  { id: 'evc', label: 'EVC' },
  { id: 'perdida_sensibilidad', label: 'Pérdida de sensibilidad' },
];

export const GASTROINTESTINAL_CONDITIONS = [
  { id: 'reflujo', label: 'Reflujo' },
  { id: 'gastritis', label: 'Gastritis' },
  { id: 'ulcera', label: 'Úlcera' },
  { id: 'colon_irritable', label: 'Colon irritable' },
];

export function blankPathologyBlock() {
  return {
    checked: false,
    conditions: [],
    evolution_time: '',
    treatment: '',
    controlled: '',
    detail: '',
  };
}

function migratePathologyBlock(saved) {
  if (!saved || typeof saved !== 'object') return blankPathologyBlock();
  if ('conditions' in saved || 'detail' in saved) {
    return {
      ...blankPathologyBlock(),
      ...saved,
      conditions: Array.isArray(saved.conditions) ? saved.conditions : [],
    };
  }
  const notes = String(saved.notes || '').trim();
  return {
    ...blankPathologyBlock(),
    checked: !!saved.checked,
    conditions: saved.checked && notes ? ['otro'] : [],
    detail: notes,
  };
}

export function emptyIntakeAdult() {
  return {
    schema_version: INTAKE_SCHEMA_VERSION,
    record_type: 'adult',
    header: {
      business_name: '',
      folio: '',
      clinic_address: '',
      form_date: '',
    },
    personal: {
      full_name: '',
      birth_date: '',
      age: '',
      biological_sex: '',
      sex: '',
      gender: '',
      marital_status: '',
      education: '',
      curp: '',
      blood_type: '',
      phone: '',
      email: '',
      address_line1: '',
      address_line2: '',
      address: '',
      emergency_contact_name: '',
      emergency_contact_phone: '',
      emergency_contact_relationship: '',
      emergency_contact: '',
      occupation: '',
      allergies: { has_allergies: false, text: '' },
      current_medications: [],
      treating_physician: { name: '', specialty: '', phone: '' },
    },
    pathological: {
      cardiovascular: blankPathologyBlock(),
      pulmonary: blankPathologyBlock(),
      gastrointestinal: blankPathologyBlock(),
      endocrine: blankPathologyBlock(),
      dermatological: blankPathologyBlock(),
      neurological: blankPathologyBlock(),
      cancer: blankPathologyBlock(),
    },
    non_pathological: {
      smoking: blankPathologyBlock(),
      alcoholism: blankPathologyBlock(),
      substance_use: blankPathologyBlock(),
      trauma: blankPathologyBlock(),
      surgeries: blankPathologyBlock(),
      physical_activity: '',
      footwear_habits: [],
      foot_hygiene: '',
    },
    family_history: {
      diabetes: blankPathologyBlock(),
      hypertension: blankPathologyBlock(),
      peripheral_vascular: blankPathologyBlock(),
      amputations: blankPathologyBlock(),
      neuropathies: blankPathologyBlock(),
      rheumatologic: blankPathologyBlock(),
      cancer: blankPathologyBlock(),
      seizures: blankPathologyBlock(),
    },
    personal_extended: {
      chief_complaint: '',
      pain_eva: '',
      evolution_value: '',
      evolution_unit: 'meses',
      symptoms: {
        pain: false,
        burning: false,
        pruritus: false,
        inflammation: false,
        secretion: false,
        odor: false,
        bleeding: false,
      },
      prior_therapies: '',
      lab_entries: [],
      problems_noticed: [],
      lab_tests_done: '',
      lab_tests_when: '',
      lab_tests_results: '',
      main_problem_home_work: '',
    },
    podiatric: {
      gait: { independent: false, dependent: false, with_support: false, devices: '' },
      gait_type: '',
      exam_position: { sedente: false, supine: false, bipedestation: false },
      foot_morphology: { cavus: false, flat: false, equinus: false, equinus_varus: false, other: '' },
      plantar_print: '',
      reflexes: {
        left: { achilles: '', patellar: '', plantar: '', babinski: '' },
        right: { achilles: '', patellar: '', plantar: '', babinski: '' },
      },
      pulses: {
        pedio_left: false,
        pedio_right: false,
        tibial_post_left: false,
        tibial_post_right: false,
      },
      pulses_notes: '',
      temperature: '',
      capillary_refill: '',
      edema: '',
      sensitivity: { monofilament: '', vibratory: '', painful: '', thermal: '' },
      tuning_fork: '',
      monofilament: '',
      alterations: {
        dermal: { description: '', photo: null },
        ungueal: { description: '', photo: null },
        digital: { description: '', photo: null },
      },
    },
    biomechanical: {
      limitation: '',
      column_spine: '',
      segments: {
        right: {
          hip: '', knee: '', hindfoot: '', forefoot: '', midfoot: '',
          first_ray: '', lesser_toes: '', femoral_torsion: '', tibial_torsion: '', ankle: '',
        },
        left: {
          hip: '', knee: '', hindfoot: '', forefoot: '', midfoot: '',
          first_ray: '', lesser_toes: '', femoral_torsion: '', tibial_torsion: '', ankle: '',
        },
      },
      upper_limbs_mobility: '',
      voluntary_control: '',
      postural_control: '',
      imbalance: '',
      rigidity: '',
      dysmetria: '',
      eye_symmetry_glasses: '',
    },
    muscle_dynamic: {
      muscle_exam: '',
      dynamic_exam: '',
      footwear: '',
    },
    diagnosis_treatment: {
      diagnosis_primary: '',
      diagnosis_secondary: [],
      cie10: '',
      prognosis: '',
      treatment_plan: '',
      procedure_today: '',
      post_care_instructions: '',
      next_appointment: '',
      diagnosis: '',
      orthotic_treatment: '',
    },
  };
}

export function emptyConsent() {
  return {
    patient_signature_name: '',
    podiatrist_name: '',
    podiatrist_license: '',
    signed_at: '',
    authorized: false,
    clinical_photos_consent: '',
  };
}

export const CONSENT_LEGAL_TEXT = `Consentimiento informado para la práctica podológica. Antes de prestarle la atención podológica que usted requiere, por imperativo legal es obligatorio que usted exprese su autorización por escrito para la realización del servicio podológico. Se hará además una exploración física; serán procedimientos realizados por técnicas no invasivas y que podrían originar dolor. Los riesgos derivados del tratamiento podológico incluyen: dolor durante o tras la manipulación, ligero sangrado, hematoma, irritación local e infección superficial si no se siguen las medidas de asepsia indicadas. La información clínica y las fotografías autorizadas se utilizarán con fines clínicos, seguimiento terapéutico y documentación del expediente, no con fines exclusivamente científicos. Usted puede revocar este consentimiento en cualquier momento sin necesidad de explicación.`;

export const INTAKE_WIZARD_STEPS = [
  { id: 'personal', title: 'Datos personales' },
  { id: 'antecedents', title: 'Antecedentes' },
  { id: 'personal_ext', title: 'Historia personal' },
  { id: 'podiatric', title: 'Valoración podológica' },
  { id: 'biomechanical', title: 'Biomecánica' },
  { id: 'muscle', title: 'Exploración muscular' },
  { id: 'diagnosis', title: 'Diagnóstico y tratamiento' },
  { id: 'consent', title: 'Consentimiento' },
];

function mergePathologySection(baseSection, savedSection) {
  const out = { ...baseSection };
  for (const key of Object.keys(baseSection)) {
    out[key] = migratePathologyBlock(savedSection?.[key]);
  }
  return out;
}

function migratePulsePresent(val) {
  if (val === true) return true;
  if (val === false) return false;
  const s = String(val || '').trim().toLowerCase();
  if (!s) return false;
  return s === 'present' || s === 'presente' || s === 'si' || s === 'sí' || s === 'yes';
}

function mergeAlterationEntry(saved, legacyText) {
  if (saved && typeof saved === 'object' && !Array.isArray(saved)) {
    const photo = saved.photo;
    return {
      description: String(saved.description ?? legacyText ?? '').trim(),
      photo:
        photo && typeof photo === 'object' && String(photo.url || '').trim()
          ? {
              id: String(photo.id || ''),
              url: String(photo.url || ''),
              uploaded_at: String(photo.uploaded_at || ''),
            }
          : null,
    };
  }
  return { description: String(legacyText || saved || '').trim(), photo: null };
}

function mergePodiatric(saved) {
  const base = emptyIntakeAdult().podiatric;
  const s = saved && typeof saved === 'object' ? saved : {};
  const pulses = s.pulses || {};
  const fm = s.foot_morphology || {};
  let plantar_print = String(s.plantar_print || '').trim();
  if (!plantar_print) {
    if (fm.flat) plantar_print = 'plana';
    else if (fm.cavus) plantar_print = 'cavo';
  }
  const sens = s.sensitivity || {};
  const legacySens = {
    monofilament: String(sens.monofilament || s.monofilament || '').trim(),
    vibratory: String(sens.vibratory || s.tuning_fork || '').trim(),
    painful: String(sens.painful || '').trim(),
    thermal: String(sens.thermal || '').trim(),
  };
  const alt = s.alterations || {};
  return {
    ...base,
    ...s,
    gait: { ...base.gait, ...(s.gait || {}) },
    gait_type: String(s.gait_type || '').trim(),
    plantar_print,
    reflexes: {
      left: { ...base.reflexes.left, ...(s.reflexes?.left || {}) },
      right: { ...base.reflexes.right, ...(s.reflexes?.right || {}) },
    },
    pulses: {
      pedio_left: migratePulsePresent(pulses.pedio_left),
      pedio_right: migratePulsePresent(pulses.pedio_right),
      tibial_post_left: migratePulsePresent(pulses.tibial_post_left),
      tibial_post_right: migratePulsePresent(pulses.tibial_post_right),
    },
    pulses_notes: String(s.pulses_notes || '').trim(),
    temperature: String(s.temperature || '').trim(),
    capillary_refill: String(s.capillary_refill ?? '').trim(),
    edema: String(s.edema || '').trim(),
    sensitivity: legacySens,
    alterations: {
      dermal: mergeAlterationEntry(
        typeof alt.dermal === 'object' && alt.dermal ? alt.dermal : null,
        typeof alt.dermal === 'string' ? alt.dermal : ''
      ),
      ungueal: mergeAlterationEntry(
        typeof alt.ungueal === 'object' && alt.ungueal ? alt.ungueal : null,
        typeof alt.ungueal === 'string' ? alt.ungueal : ''
      ),
      digital: mergeAlterationEntry(
        typeof alt.digital === 'object' && alt.digital ? alt.digital : null,
        typeof alt.digital === 'string' ? alt.digital : ''
      ),
    },
  };
}

export function mergeIntakeAdult(saved) {
  const base = emptyIntakeAdult();
  if (!saved || typeof saved !== 'object') return base;

  const personal = {
    ...base.personal,
    ...(saved.personal || {}),
    allergies: {
      ...base.personal.allergies,
      ...(saved.personal?.allergies || {}),
    },
    treating_physician: {
      ...base.personal.treating_physician,
      ...(saved.personal?.treating_physician || {}),
    },
    current_medications: Array.isArray(saved.personal?.current_medications)
      ? saved.personal.current_medications
      : base.personal.current_medications,
    biological_sex:
      saved.personal?.biological_sex || saved.personal?.sex || base.personal.biological_sex,
    address_line1:
      saved.personal?.address_line1 || saved.personal?.address || base.personal.address_line1,
  };

  const pe = saved.personal_extended || {};
  const personal_extended = {
    ...base.personal_extended,
    ...pe,
    symptoms: { ...base.personal_extended.symptoms, ...(pe.symptoms || {}) },
    lab_entries: Array.isArray(pe.lab_entries) ? pe.lab_entries : [],
  };

  const dt = saved.diagnosis_treatment || {};
  const diagnosis_treatment = {
    ...base.diagnosis_treatment,
    ...dt,
    diagnosis_primary: dt.diagnosis_primary || dt.diagnosis || base.diagnosis_treatment.diagnosis_primary,
    diagnosis_secondary: Array.isArray(dt.diagnosis_secondary) ? dt.diagnosis_secondary : [],
  };

  return {
    ...base,
    ...saved,
    schema_version: INTAKE_SCHEMA_VERSION,
    record_type: saved.record_type || 'adult',
    header: { ...base.header, ...(saved.header || {}) },
    personal,
    pathological: mergePathologySection(base.pathological, saved.pathological),
    non_pathological: {
      ...base.non_pathological,
      ...mergePathologySection(
        {
          smoking: base.non_pathological.smoking,
          alcoholism: base.non_pathological.alcoholism,
          substance_use: base.non_pathological.substance_use,
          trauma: base.non_pathological.trauma,
          surgeries: base.non_pathological.surgeries,
        },
        saved.non_pathological
      ),
      physical_activity: saved.non_pathological?.physical_activity || '',
      footwear_habits: Array.isArray(saved.non_pathological?.footwear_habits)
        ? saved.non_pathological.footwear_habits
        : [],
      foot_hygiene: saved.non_pathological?.foot_hygiene || '',
    },
    family_history: mergePathologySection(base.family_history, saved.family_history),
    personal_extended,
    podiatric: mergePodiatric(saved.podiatric),
    biomechanical: {
      ...base.biomechanical,
      ...(saved.biomechanical || {}),
      segments: {
        right: { ...base.biomechanical.segments.right, ...(saved.biomechanical?.segments?.right || {}) },
        left: { ...base.biomechanical.segments.left, ...(saved.biomechanical?.segments?.left || {}) },
      },
    },
    muscle_dynamic: { ...base.muscle_dynamic, ...(saved.muscle_dynamic || {}) },
    diagnosis_treatment,
  };
}

/** Alertas para listado y banner (alergias, diabetes, anticoagulante). */
export function computeClinicalAlerts(intake) {
  if (!intake) return [];
  const alerts = [];
  const personal = intake.personal || {};
  if (personal.allergies?.has_allergies || String(personal.allergies?.text || '').trim()) {
    alerts.push({ id: 'allergy', label: 'Alergias registradas' });
  }
  const endo = intake.pathological?.endocrine || {};
  const endoConds = endo.conditions || [];
  if (
    endo.checked ||
    endoConds.includes('dm1') ||
    endoConds.includes('dm2') ||
    /diabet/i.test(endo.detail || '')
  ) {
    alerts.push({ id: 'diabetes', label: 'Diabetes / endocrino' });
  }
  const cardio = intake.pathological?.cardiovascular || {};
  if (cardio.checked && (cardio.conditions || []).includes('anticoagulante')) {
    alerts.push({ id: 'anticoag', label: 'Anticoagulante' });
  }
  const meds = personal.current_medications || [];
  if (
    meds.some((m) =>
      /warfarina|heparina|apixaban|rivaroxaban|acenocumarol|anticoag/i.test(
        `${m.name} ${m.dose}`
      )
    )
  ) {
    alerts.push({ id: 'anticoag_med', label: 'Posible anticoagulación (medicamentos)' });
  }
  return alerts;
}

export const TEMPERATURE_OPTIONS = [
  { value: 'normal', label: 'Normal' },
  { value: 'fria', label: 'Fría' },
  { value: 'caliente', label: 'Caliente' },
];

export const EDEMA_OPTIONS = [
  { value: 'ausente', label: 'Ausente' },
  { value: 'leve', label: 'Leve' },
  { value: 'moderado', label: 'Moderado' },
  { value: 'severo', label: 'Severo' },
];

export const GAIT_TYPE_OPTIONS = [
  { value: 'pronadora', label: 'Pronadora' },
  { value: 'supinadora', label: 'Supinadora' },
  { value: 'antalgica', label: 'Antálgica' },
  { value: 'claudicante', label: 'Claudicante' },
];

export const PLANTAR_PRINT_OPTIONS = [
  { value: 'normal', label: 'Normal' },
  { value: 'plana', label: 'Plana' },
  { value: 'cavo', label: 'Cavo' },
];

export const SENSITIVITY_ROWS = [
  { key: 'monofilament', label: 'Monofilamento' },
  { key: 'vibratory', label: 'Vibratoria' },
  { key: 'painful', label: 'Dolorosa' },
  { key: 'thermal', label: 'Térmica' },
];

export const ALTERATION_ZONES = [
  { key: 'dermal', label: 'Dérmicas' },
  { key: 'ungueal', label: 'Ungueales' },
  { key: 'digital', label: 'Digitales' },
];

export const REFLEX_OPTIONS = [
  { value: '', label: '—' },
  { value: 'present', label: 'Presente' },
  { value: 'hyper', label: 'Hiperreflexia' },
  { value: 'hypo', label: 'Hiporreflexia' },
  { value: 'absent', label: 'Ausente' },
  { value: 'babinski', label: 'Babinski' },
];

export const LIMITATION_OPTIONS = [
  { value: '', label: '—' },
  { value: 'leve', label: 'Leve' },
  { value: 'moderada', label: 'Moderada' },
  { value: 'grave', label: 'Grave' },
  { value: 'completa', label: 'Completa' },
];

/** Síntomas adulto (v2); sin ítems pediátricos. */
export const ADULT_SYMPTOM_OPTIONS = [
  ['pain', 'Dolor'],
  ['burning', 'Ardor'],
  ['pruritus', 'Prurito'],
  ['inflammation', 'Inflamación'],
  ['secretion', 'Secreción'],
  ['odor', 'Mal olor'],
  ['bleeding', 'Sangrado'],
];
